import React, { createContext, useState, useContext, useEffect } from 'react';

const ViewModeContext = createContext();

export const useViewMode = () => {
  const context = useContext(ViewModeContext);
  if (!context) {
    throw new Error('useViewMode must be used within a ViewModeProvider');
  }
  return context;
};

export const ViewModeProvider = ({ children }) => {
  // Initialize from localStorage or default to 'grid'
  const [viewMode, setViewMode] = useState(() => {
    const saved = localStorage.getItem('catalogViewMode');
    return saved || 'grid';
  });

  // Save to localStorage whenever viewMode changes
  useEffect(() => {
    localStorage.setItem('catalogViewMode', viewMode);
  }, [viewMode]);

  const toggleViewMode = () => {
    setViewMode(prev => prev === 'grid' ? 'magazine' : 'grid');
  };

  const value = {
    viewMode,
    setViewMode,
    toggleViewMode,
    isGridView: viewMode === 'grid',
    isMagazineView: viewMode === 'magazine'
  };

  return (
    <ViewModeContext.Provider value={value}>
      {children}
    </ViewModeContext.Provider>
  );
};

export default ViewModeContext;